import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import { isMobile } from 'react-device-detect';
import { Box, Grid } from '@material-ui/core';
import logo from '../../assets/img/logo-white.png';
import AppStore from '../../assets/img/AppStoreBoton.png';
import PlayStore from '../../assets/img/PlayStoreBoton.png';
import MobileFooter from './parts/MobileFooter';
import { googlePlayGotmyURL, appleStoreGotmyURL } from '../../environment/environment';
import { useResponsiveSize } from '../../config/hooks/useResponsiveSize';
import { DeviceSensitive, UIBreakPoint } from '../../pages/StreamingWEBRTC/config';
import { useStyles } from './styles';

const Footer: FC = () => {
    const classes = useStyles();
    const isMobileUI = useResponsiveSize(UIBreakPoint, DeviceSensitive);

    if (
        window.location.pathname.includes('api/payment/stripe_callback') ||
        window.location.pathname.includes('paypal_callback') ||
        window.location.pathname.includes('instagramSignUp') ||
        window.location.pathname.includes('streamingDacastMobile') ||
        window.location.pathname.includes('/talent') ||
        window.location.pathname.includes('/wellness') ||
        (window.location.pathname.includes('streaming') && isMobile)
    ) {
        return null;
    }

    const renderDesktopFooter = () => (
        <Box className={classes.container}>
            <Grid container className={classes.grid}>
                <Grid container item md={3} direction="column">
                    <img src={logo} className={classes.logo} alt="logo" />
                    <span className="Font-peq">
                        {new Date().getFullYear()} {i18next.t('FooterComponentGotmyCompName')} <br />{' '}
                        {i18next.t('FooterComponentAllRightsReserved')}
                    </span>
                </Grid>

                <Grid container item md={6} direction="row" className={classes.linksGrid}>
                    <Grid container item md={3} direction="column">
                        <Link to="/terms/service">{i18next.t('FooterComponentTermsOfService')}</Link>
                        <Link to="/terms/privacy">{i18next.t('FooterComponentPrivacyPolicy')}</Link>
                    </Grid>
                    <Grid container item md={3} direction="column">
                        <a rel="noreferrer" target="_blank" href="https://www.instagram.com/gotmydotcom/">
                            Instagram
                        </a>
                        <a rel="noreferrer" target="_blank" href="https://www.linkedin.com/company/gotmy/">
                            Linkedin
                        </a>
                        <a rel="noreferrer" target="_blank" href="https://twitter.com/gotmydotcom/">
                            Twitter
                        </a>
                        <a rel="noreferrer" target="_blank" href="https://www.facebook.com/gotmydotcom/">
                            Facebook
                        </a>
                        <a rel="noreferrer" target="_blank" href="https://www.pinterest.com/gotmydotcom/">
                            Pinterest
                        </a>
                    </Grid>
                    <Grid container item md={3} direction="column">
                        <a rel="noreferrer" target="_blank" href="https://blog.gotmy.com">
                            {i18next.t('FooterComponentContact')}
                        </a>
                        <a rel="noreferrer" target="_blank" href="https://blog.gotmy.com/business/">
                            {i18next.t('FooterComponentInvestors')}
                        </a>
                        <a rel="noreferrer" target="_blank" href="https://blog.gotmy.com/blog/">
                            {i18next.t('FooterComponentBlog')}
                        </a>
                    </Grid>
                </Grid>

                <Grid item md={3}>
                    <h5 className={classes.appLinksTitle}>{i18next.t('FooterComponentDownloadAppTitle')}</h5>
                    <p className={classes.appLinksDescription}>
                        {i18next.t('FooterComponentDownloadAppDescription')}
                    </p>

                    <Box className={classes.appStoresLinks}>
                        <a rel="noreferrer" href={appleStoreGotmyURL} target="_blank">
                            <img className={classes.appStoreLinkIcon} src={AppStore} alt="App Store" />
                        </a>
                        <a rel="noreferrer" href={googlePlayGotmyURL} target="_blank">
                            <img className={classes.appStoreLinkIcon} src={PlayStore} alt="Google Play" />
                        </a>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );

    return <footer>{isMobileUI ? <MobileFooter /> : renderDesktopFooter()}</footer>;
};

export default Footer;
